const { mergeMap } = require('rxjs/operators');
const { ofType } = require('redux-observable');

const { marketplace: marketplaceApi } = require('@doctoroncallcom/api');
const { GET_SERVICES, GET_CATALOGUE, GET_PACKAGES } = require('./constants');

const {
  getServicesSuccess,
  getServicesError,
  packagesSuccess,
  packagesError,
  catalogueSuccess,
  catalogueError,
} = require('./actions');

const getServices = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_SERVICES),
    mergeMap((action) =>
      marketplaceApi.services
        .productCategory(marketplace, {
          mode: 2,
          _page: action.payload.size,
          _pagesize: action.payload.pageSize,
          filters: `package_category:"${action.payload.categorySearch}"`,
        })
        .then((response) => getServicesSuccess(response.data))
        .catch((error) => getServicesError(error))
    )
  );

const packages = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_PACKAGES),
    mergeMap((action) =>
      marketplaceApi.services
        .packages(marketplace, {
          uuid: action.payload.uuid,
        })
        .then((response) => packagesSuccess(response.data))
        .catch((error) => packagesError(error))
    )
  );

const catalogue = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_CATALOGUE),
    mergeMap((action) =>
      marketplaceApi.services
        .catalogue(marketplace)
        .then((response) => catalogueSuccess(response.data))
        .catch((error) => catalogueError(error))
    )
  );

module.exports = {
  getServices,
  packages,
  catalogue,
};
